import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../data/entrepminds";

const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#f3eedf]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-14"
        >
          <div className="section-eyebrow mb-4">Voices from the field</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05]">
            Founders building <span className="gold-text">on GrowthOS™</span>.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, idx) => (
            <motion.figure
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.08 }}
              data-testid={`testimonial-${idx}`}
              className="em-card p-7 backdrop-blur-md bg-white/85 flex flex-col"
            >
              <div className="flex items-center justify-between mb-5">
                <Quote size={22} className="text-[#8a6a10]" />
                <div className="flex gap-1 text-[#8a6a10]">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <Star key={i} size={12} fill="#d4af37" strokeWidth={0} />
                  ))}
                </div>
              </div>

              <blockquote className="text-[#3f3a30] text-base leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              <div className="font-mono-em text-[10px] tracking-[0.2em] uppercase text-[#8a6a10] mt-6">
                {t.metric}
              </div>

              <div className="gold-divider my-5" />

              <figcaption className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full flex items-center justify-center bg-gradient-to-br from-[#0a0a0a] to-[#3a2e0a] text-[#d4af37] font-display text-sm font-semibold shrink-0">
                  {t.initials}
                </div>
                <div>
                  <div className="text-[#0a0a0a] font-medium leading-tight">{t.name}</div>
                  <div className="text-xs text-[#6b6356] mt-0.5">
                    {t.role} · {t.company}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
